import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'approve': {
    title: '审核',
    slot: true,
    width: 80,
    columnParams: { bgEdit: true }
  },
  'w_invo_infoid': {
    title: '外部制票通知单号',
    type: 'input',
    equation: all,
    width: 150
  },
  'invo_infoid': {
    title: '制票通知单号',
    type: 'input',
    equation: all,
    slot: true,
    width: 120
  },
  'cust_name': {
    title: '开票客户名称',
    type: 'input',
    width: 160
  },
  'order_cust_name': {
    title: '订单客户名称',
    type: 'input',
    equation: cusname,
    width: 160
  },
  'description': {
    title: '产品名称',
    type: 'input',
    equation: cusname,
    width: 180
  },
  'use_zzfld9': {
    title: '开票件数',
    width: 90,
    xlsxFmt: {
      t: 'n'
    }
  },
  'use_bot': {
    title: '开票瓶数',
    width: 90,
    xlsxFmt: {
      t: 'n'
    }
  },
  'net_value': {
    title: '税价合计',
    width: 100,
    xlsxFmt: {
      t: 'n'
    }
  },
  'mak_date': {
    title: '开票日期',
    type: 'date',
    width: 100,
    equation: all
  },
  'invo_id': {
    title: '发票号',
    type: 'input',
    width: 100,
    equation: cusname,
    slot: true,
    columnParams: { bgEdit: true }
  },
  'pdf_url': {
    title: '发票PDF',
    // type: 'input',
    width: 100,
    slot: true,
  },
  'ems_number': {
    title: 'ems单号',
    type: 'input',
    width: 100,
    equation: cusname,
    slot: true,
    columnParams: { bgEdit: true }
  },
  'ems_datum': {
    title: 'ems日期',
    type: 'date',
    width: 100,
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'manual_invo': {
    title: '提货票',
    type: 'input',
    equation: cusname,
    slot: true,
    columnParams: { bgEdit: true }
  },
  'chan_date': {
    title: '换票日期',
    type: 'date',
    equation: all
  },
  'zzfld00001h': {
    describe: true,
    title: '营销单元(订单客户)',
    type: 'select',
    equation: all,
    dictionary: 'sale',
    width: 180
  },
  'zzfld00003e': {
    describe: true,
    title: '基地(订单客户)',
    type: 'select',
    equation: all,
    dictionary: 'base'
  },
  'order_customer': {
    title: '订单客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户编号'
    }
  },
  'customer': {
    title: '开票客户编码',
    type: 'dialog',
    dialog: {
      component: 'ClientSelect',
      title: '开票客户编码'
    }
  },
  'order_customer_type': {
    describe: true,
    title: '订单客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'use_quantity': {
    title: '开票数量',
    width: 100,
    xlsxFmt: {
      t: 'n'
    }
  },
  'net_price': {
    title: '含税单价',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002a': {
    describe: true,
    title: '折扣类型',
    type: 'select',
    equation: city,
    dictionary: 'A0037'
  },
  'zzfld00002g': {
    title: '折后含税单价',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002i': {
    title: '折扣额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ordered_prod': {
    title: '产品编号',
    type: 'input',
    equation: cusname
  },
  'zzfld00002s': {
    title: '规格型号',
    type: 'input',
    equation: cusname,
    width: 150
  },
  'zzfld00002t': {
    title: '单位',
    type: 'input',
    equation: cusname
  },
  'zzfld00002e': {
    title: '税率'
  },
  'object_id': {
    title: '销售订单号',
    type: 'input',
    equation: cusname
  },
  'send_qty': {
    title: '已发运数量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'warehouse': {
    describe: true,
    title: '仓库',
    type: 'select',
    equation: all,
    dictionary: 'A0039'
  },
  'invo_item': {
    title: '行号',
    width: 70,
    formatter: ({ cellValue }) => cellValue && Number(cellValue)
  },
  'inv_status': {
    describe: true,
    title: '制票通知单状态',
    type: 'select',
    equation: all,
    dictionary: 'A0035',
    width: 150
  },
  'hd_remark': {
    title: '销售订单抬头备注',
    type: 'input',
    width: 200
  },
  'remark': {
    title: '制票通知单抬头备注',
    type: 'input',
    width: 200
  },
  'item_remark': {
    title: '制票通知单行项目备注',
    type: 'input',
    width: 200
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: cusname,
    formatter: ({ cellValue }) => formatSapDate(cellValue),
    defaultVal: new Date()
  },
  'inf_type': {
    describe: true,
    title: '制票通知单类型',
    type: 'select',
    equation: city,
    dictionary: 'A0022',
    width: 180
  },
  'kp_message': {
    title: '推送开票系统'
  },
  'chfl': {
    title: '存货分类',
    describe: true,
    type: 'select',
    dictionary: 'A0019'
  },
  'inv_amount': {
    title: '发票总金额',
    xlsxFmt: {
      t: 'n'
    }
  },
  inv_type: {
    describe: true,
    title: '发票类型',
    type: 'select',
    dictionary: 'A0032'
  },
  'reward_name': {
    title: '项目类型名称',
    type: 'input',
  },
  'zy_pe_month': {
    title: '占用配额计划月份'
  }
}



// WEBPACK FOOTER //
// ./src/views/invoice-manage/config/invoiceDetailQuery.js